import client from "./ApiService";

class RoyaltiesEditorService {
  constructor(params) {
    this.url = "/royalties-editors";
  }

  get() {
    return client.get(this.url);
  }

  filter(filter) {
    return client.get(`${this.url}${filter ? '?name_contains='+filter : ''}`);
  }
  
  slugfilter(filter) {
    return client.get(`${this.url}${filter ? '?_q='+filter : ''}`);
  }
}

export default new RoyaltiesEditorService();
